module.exports = __webpack_public_path__ + "img/shield_covid_green.b9d2f263.svg";